import React, { useContext, Fragment } from 'react';
import './Room.css';
import PaxDispatch from '../PaxDispatch';
import RoomDetail from './RoomDetail';
import { SET_EDIT_MODE, REMOVE_ROOM } from '../../Constant/constants';
import PaxInfo from './PaxInfo';

const Room = ({ room, roomIndex, isEdit, removable = true, paxConfig }) => {
  const dispatch = useContext(PaxDispatch);
  const roomNumber = roomIndex + 1;
  return (
    <div className="room-container">
      <div className="room-info">
        <p className="darkText font16 latoBlack capText">{`Room ${roomNumber}`}</p>
      </div>
      <div className="room-component-container">
        <div className="pax-info-container">
          <div className="pax-info-leftContainer">
            {!isEdit ? (
              <>
                <PaxInfo {...room} />
                <a
                  className="room_editBtn"
                  onClick={() => dispatch({ type: SET_EDIT_MODE, index: roomIndex })}
                >
                  Edit
                </a>
              </>
            ) : (
              <RoomDetail {...room} roomIndex={roomIndex} paxConfig={paxConfig} />
            )}
          </div>
          {removable && (
            <a
              className="room_removeBtn"
              onClick={() => dispatch({ type: REMOVE_ROOM, index: roomIndex })}
            >
              Remove
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default Room;
